SUGApp.controller('modalMessageDisplayController', ['$scope','SUGUtilities','modalMessageService', '$filter', '$location', '$sce', '$modal', '$window', '$timeout',
	function($scope, SUGUtilities, modalMessageService, $filter, $location, $sce, $modal, $window, $timeout){

	$scope.getEpochTime = function() {
		var newDate = new Date();
		newDate = ( newDate.getTime() - newDate.getMilliseconds() ) / 1000;
		return newDate;
	};

	$scope.data = SUGUtilities.lowerCaseKeys($window.sug_memberinfo);

	$scope.getMessageToDisplay = function() {
		if($scope.data.displaypage === '/index.cfm?go=w.manageSignUp'){
			// for regex path matching to work across routes we need to report the entire path
			// for now, enabled for the new wizard only
			$scope.data.displaypageroute = $window.location.href.replace($window.location.origin,'');
			// needed for IE10
			if( typeof $window.location.origin === 'undefined' ){
				$scope.data.displaypageroute = $window.location.pathname + $window.location.search + $window.location.hash;
			}
		}
		modalMessageService.determineModalMessageToDisplay($scope.data)
			.then(function(result){
				result = SUGUtilities.lowerCaseKeys(result.data);

				if (result.success){
					$scope.displayModal = true;
					$scope.modalMessage = result.data;
					$scope.modalMessage.uploadsrc = false;
					$scope.modalMessage.mediafilewithepoch = $scope.modalMessage.mediafile + '?v=' + $scope.epochTime;
					$scope.modalMessage.trustmediafile = $sce.trustAsResourceUrl($scope.modalMessage.mediafile);
					$scope.modalMessage.modalmaxsize = $scope.modalMessage.mediasize + 80 + 'px';
				} else {
					$scope.displayModal = false;
				}
			}
		);
	};

	/* Alert Window Controller */
	$scope.displayModalMessage = function( confMsg, titleMsg, modalMessage ){

		var displayModalWindow = $modal.open({
			templateUrl: '/view/templates/marketingmodal.html?v='+$scope.epochTime,
			controller: modalController,
			resolve : {
				modalMessage: function(){ return $scope.modalMessage; },
				title: function(){ return titleMsg; },
				confirmation: function(){ return confMsg; },
				cancel: function(){ return 'Cancel'; },
				ok: function(){ return 'Ok'; }
			}
		});

		displayModalWindow.result
			.then( function(response){
				//do nothing
			}, function(response){
				//Don't do anything
				//Cancel
			});
	};

	var supportedScreenSize = true;
	if(typeof viewportSize !== 'undefined' && viewportSize.getWidth() <= 991){
		supportedScreenSize = false;
	}

	$scope.displayModal = false;
	$scope.previewMode = false;
	$scope.epochTime = $scope.getEpochTime();
	if(supportedScreenSize){
		$scope.getMessageToDisplay();
	}

	// trigger an on-demand check for modal messages (useful for route based modals on route change)
	$scope.$on('checkForModalMessage',function(){
		if(supportedScreenSize){
			$scope.getMessageToDisplay();
		}
	});

	/* Modal Controller */
	var modalController = ['$scope', '$modalInstance', 'confirmation', 'ok', 'cancel', 'modalMessage', 'title', '$filter',
		function ($scope, $modalInstance, confirmation, ok, cancel, modalMessage, title, $filter) {
			$scope.modalMessage = modalMessage;
			$scope.confirmationTitle = title;
			$scope.confirmationMessage = confirmation;
			$scope.okBtn = typeof ok !== 'undefined' ? ok : 'Okay';
			$scope.cancelBtn = typeof cancel !== 'undefined' ? cancel : 'Cancel';
			$scope.previewMode = false;
			$scope.ok = function () {
				$modalInstance.close(true);
			};
			$scope.cancel = function () {
				$modalInstance.dismiss(false);
			};
		}
	];

}]);

SUGApp.filter("trust", ['$sce', function($sce) {
	return function(htmlCode){
		return $sce.trustAsHtml(htmlCode);
	};
}]);
